import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
var _excluded = ["id"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createQueryKey, useAxiosClient, useMutation, useQuery } from '@lumahealthhq/ui-model';
var basePath = 'assistantInstances';
export function useAssistantInstances(options) {
  var axiosClient = useAxiosClient();
  var mutationFn = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(patientId) {
      var _yield$axiosClient$po, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axiosClient.post("/v2/".concat(basePath, "/patients/").concat(patientId, "/completions"));
          case 2:
            _yield$axiosClient$po = _context.sent;
            data = _yield$axiosClient$po.data;
            return _context.abrupt("return", data);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function mutationFn(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var mutation = useMutation([basePath], mutationFn, options);
  return mutation;
}
export function useAssistantInstancesById(_ref2, options) {
  var id = _ref2.id,
    params = _objectWithoutProperties(_ref2, _excluded);
  var axiosClient = useAxiosClient();
  var url = "v2/assistantInstances/".concat(id);
  function queryFn() {
    return _queryFn.apply(this, arguments);
  }
  function _queryFn() {
    _queryFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _yield$axiosClient$ge, data;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return axiosClient.get(url, {
              params: _extends({}, params)
            });
          case 2:
            _yield$axiosClient$ge = _context2.sent;
            data = _yield$axiosClient$ge.data;
            return _context2.abrupt("return", data);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _queryFn.apply(this, arguments);
  }
  var queryKey = createQueryKey(basePath, url);
  return useQuery(queryKey, queryFn, options);
}